import { Search } from "lucide-react";
import { cn } from "src/lib/utils";
import { Input } from "../ui/input";

interface SearchFieldProps {
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    placeholder: string;
    className?: string;
}

export default function SearchField({ searchTerm, setSearchTerm, placeholder, className }: SearchFieldProps) {
    return (
        <div className={cn("relative", className)}>
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary-400 w-5 h-5" />
            <Input
                type="text"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-primary-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
      </div>
    )
}